
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventDelete extends Vue {
    @Prop({type: Object, default: null}) private template!: any;
    @Prop({type: Object, default: null}) private event!: any;

    @Action('admin/events/deleteTemplate') private deleteTemplate!: any;
    @Action('admin/events/readTemplates') private readTemplates!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      await this.deleteTemplate({event: this.event, template: this.template});
      await this.readTemplates({id: this.event.id});
      this.dialog = false;
      this.loading = false;
    }
  }
